import { serviceUrl } from '../config/net.config'
import request from '@/utils/request'
/**
 * 根据字典取数据
 * @param {*} params 
 * @returns 
 */
export function getSysDict(params) {
    return request({
      url: '/base/getSysDict?dictTypeCode=' + params,
      method: 'get',
      token:sessionStorage.getItem('xzztcToken')
    })
  }
  export function addApplyAuthorization(data) {
    return request({
      url: serviceUrl+'/api/applyAuthorization/addApplyAuthorization',
      head: 'application/json;charset=UTF-8',
      method: 'post',
      data,
      token:sessionStorage.getItem('xzztcToken')
    })
  }
  export function updatehandlestate(data) {
    return request({
      url: serviceUrl+'/api/applyAuthorization/updatehandlestate',
      head: 'application/json;charset=UTF-8',
      method: 'post',
      data,
      token:sessionStorage.getItem('xzztcToken')
    })
  }
  export function findApplyAuthorization(params) {
    return request({
      url: serviceUrl+'/api/applyAuthorization/findApplyAuthorization?id='+params,
      head: 'application/json;charset=UTF-8',
      method: 'get',
      token:sessionStorage.getItem('xzztcToken')
    })
  }